var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-another",on:{"click":function($event){return _vm.$emit('openSidebar')}}},[_c('img',{attrs:{"src":require("@/assets/icons/ui/add-another-item.png"),"alt":"add another item"}})])}
var staticRenderFns = []

export { render, staticRenderFns }